import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import HreflangTags from "@/components/HreflangTags";
import ChatWidget from "@/components/ChatWidget";
import useSmoothScroll from "@/hooks/useSmoothScroll";

export default function Layout() {
  useSmoothScroll();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen" style={{ background: "var(--ink)" }}>
      <HreflangTags />
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
